import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength } from '@gig/magic-form-builder';

var usernameValidation = function (value) {
    return /^[a-z0-9]+$/.test(value);
};
function username() {
    return {
        id: 'username',
        serverId: 'username',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step1-username',
        properties: {
            placeholder: translate('sign-up-step-one.username.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-one.username.required.error'),
            },
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-one.username-corex.length.error'),
            },
            {
                name: 'max-length',
                fn: maxLength(20),
                message: translate('sign-up-step-one.username-corex.length.error'),
            },
            {
                name: 'alphanumeric-lowercase-only',
                fn: usernameValidation,
                message: translate('sign-up-step-one.username-corex.format.error'),
            },
        ],
    };
}

export { username };
